import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container container">
        <Link to="/" className="navbar__logo">
          <img src="/images/logo-ai-dynamics.png" alt="AI Dynamics" className="navbar__logo-img" />
        </Link>

        <ul className={`navbar__menu ${menuOpen ? 'navbar__menu--open' : ''}`}>
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>{t('nav.home')}</Link></li>

          <li
            className="navbar__dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <span className={`navbar__dropdown-trigger ${['/services', '/niroprod'].includes(location.pathname) ? 'active' : ''}`}>
              {t('nav.solutions')} <FontAwesomeIcon icon={faChevronDown} className="navbar__chevron" />
            </span>
            <ul className={`navbar__dropdown-menu ${dropdownOpen ? 'navbar__dropdown-menu--open' : ''}`}>
              <li><Link to="/services">{t('nav.services')}</Link></li>
              <li><Link to="/niroprod">{t('nav.niroprod')}</Link></li>
            </ul>
          </li>

          <li><Link to="/pourquoi-nous" className={location.pathname === '/pourquoi-nous' ? 'active' : ''}>{t('nav.whyUs')}</Link></li>
          <li><Link to="/blog" className={location.pathname.startsWith('/blog') ? 'active' : ''}>{t('blog.navLabel')}</Link></li>
          <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>{t('nav.contact')}</Link></li>
        </ul>

        <div className="navbar__right">
          <div className="navbar__socials">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
          </div>

          <LanguageSwitcher />

          <Link to="/techmill" className="navbar__techmill-btn">{t('nav.techmill')}</Link>

          <button className="navbar__toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
